import { DecodedRoute } from '@/components/RoutePreview';

export interface BookingPayload {
    originPlaceId: string; // 
    destinationPlaceId: string;
    departureTime: string; // ISO string recommended 
    specialRequests: string;
    originPlace: string,
    destinationPlace: string,
    routeSelectedId: string
}

// Define the initial state using that type
export interface BookingState {
    booking: BookingPayload;
    routes: DecodedRoute[];
    loading: boolean;
    error: string | null;
    cacheId: string | null;
}

const emptyBooking: BookingPayload = {
    originPlaceId: "",
    destinationPlaceId: "",
    departureTime: "",
    specialRequests: "",
    originPlace: "",
    destinationPlace: "",
    routeSelectedId: ""
};

export const initialState: BookingState = {
    booking: emptyBooking,
    cacheId: null,
    routes: [],
    loading: false,
    error: null,
};
